<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.service_provider_request_details") }}</h4>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <v-row>
            <v-col cols="12">
              <base-image-upload-input
                col="12"
                identifier="admin_image"
                :placeholder="$t('PLACEHOLDERS.admin_image')"
                :preSelectedImage="data.image.path"
                @selectImage="selectImage"
                disabled
              />
            </v-col>
          </v-row>
          <!-- Start:: Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.provider_name')"
            v-model.trim="data.name"
            disabled
          />
          <!-- End:: Name Input -->
          <!-- start phone tel -->

          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.phone')"
            v-model="data.phone"
            disabled
          />

          <!-- end phone tel -->
          <!-- Start:: email Input -->
          <base-input
            col="6"
            :placeholder="$t('PLACEHOLDERS.email')"
            v-model.trim="data.email"
            type="email"
            disabled
          />
          <!-- End:: email Input -->

          <h3>{{ $t("PLACEHOLDERS.salon_data") }}</h3>

          <v-row>
            <v-col cols="12">
              <base-image-upload-input
                col="12"
                identifier="salon_logo"
                :placeholder="$t('PLACEHOLDERS.salon_logo')"
                @selectImage="selectImageSalon"
                :preSelectedImage="data.salon_image.path"
                disabled
              />
            </v-col>
          </v-row>

          <!-- ********** Start:: slider Data ********** -->
          <div class="col-12">
            <div class="row align-items-center">
              <v-col col="12" sm="12" md="12">
                <h4>{{ $t("PLACEHOLDERS.salon_images") }}</h4>

                <div class="images">
                  <div
                    class="image"
                    v-for="(item, index) in imgUrls"
                    :key="'j' + index"
                  >
                    <img :src="item.url" :alt="item.id" />
                  </div>
                </div>
              </v-col>
            </div>
          </div>
          <!-- <div class="col-12">
            <div class="row align-items-center">
              <v-col col="12" sm="12" md="12">
                <UploadsPhotos
                  :urls="imgUrls"
                  multiple
                  @onFileSelect="onFileSelect"
                  @onFileRemove="onFileRemove"
                  disabled
                >
                  {{ $t("PLACEHOLDERS.salon_images") }}
                  {{ $t("PLACEHOLDERS.extendPhoto") }}
                  <span class="text-danger">*</span>
                </UploadsPhotos>
              </v-col>
            </div>
          </div> -->
          <!-- ********** End::  slider Data ********** -->

          <!-- Start:: salon_name_ar Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.salon_name_ar')"
            v-model.trim="data.salon_name_ar"
            disabled
          />
          <!-- End:: salon_name_ar Input -->

          <!-- Start:: salon_name_en Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.salon_name_en')"
            v-model.trim="data.salon_name_en"
            disabled
          />
          <!-- End:: salon_name_en Input -->

          <!-- Start:: salon_description_ar Input -->
          <base-input
            col="6"
            rows="4"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.salon_description_ar')"
            v-model.trim="data.salon_description_ar"
            disabled
          />
          <!-- End:: salon_description_ar Input -->

          <!-- Start:: salon_description_en Input -->
          <base-input
            col="6"
            rows="4"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.salon_description_en')"
            v-model.trim="data.salon_description_en"
            disabled
          />
          <!-- End:: salon_description_en Input -->

          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.commercial_register')"
            v-model.trim="data.commercial_register"
            disabled
          />

          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.salon_number')"
            v-model.trim="data.salon_number"
            disabled
          />

          <!-- Start:: Deactivate Switch Input -->
          <h4>{{ $t("PLACEHOLDERS.registered_in_marouf") }}</h4>

          <div class="input_wrapper switch_wrapper my-5">
            <v-switch
              color="green"
              :label="
                data.registered_in_marouf
                  ? $t('PLACEHOLDERS.yes')
                  : $t('PLACEHOLDERS.no')
              "
              v-model="data.registered_in_marouf"
              hide-details
              disabled
            ></v-switch>

            <base-input
              col="6"
              type="text"
              :placeholder="$t('PLACEHOLDERS.marouf_number')"
              v-model.trim="data.marouf"
              disabled
            />
          </div>
          <!-- End:: Deactivate Switch Input -->

          <base-select-input
            v-if="main_sections"
            col="6"
            :optionsList="main_sections"
            :placeholder="$t('PLACEHOLDERS.main_section')"
            v-model="data.main_section"
            @input="getSubSections"
            multiple
            disabled
          />

          <base-select-input
            col="6"
            :optionsList="main_sections"
            :placeholder="$t('PLACEHOLDERS.sub_section')"
            v-model="data.sub_section"
            multiple
            disabled
          />

          <label class="mb-3" style="color: #28877b">{{
            $t("PLACEHOLDERS.address")
          }}</label>

          <base-select-input
            v-if="regions"
            col="6"
            :optionsList="regions"
            :placeholder="$t('PLACEHOLDERS.areas')"
            v-model="data.region"
            disabled
          />

          <div style="pointer-events: none">
            <ChangableMapComponent
              :lat="parseFloat(data.latitude)"
              :lng="parseFloat(data.longitude)"
              @update:lat="data.latitude = $event"
              @update:lng="data.longitude = $event"
              class="mb-5"
              disabled
            />
          </div>
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import UploadsPhotos from "../../../components/formInputs/UploadsPhotos.vue";
import ChangableMapComponent from "@/components/general/ChangableMapComponent";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "CreateCity",

  components: {
    UploadsPhotos,
    ChangableMapComponent,
  },

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data
      EnRegex: /[\u0600-\u06FF]/,

      // Start:: Data Collection To Send
      data: {
        image: {
          path: "",
          file: "",
        },
        salon_image: {
          path: "",
          file: "",
        },
        name: null,
        phone: null,
        email: null,
        password: null,
        passwordConfirmation: null,
        salon_name_ar: null,
        salon_name_en: null,
        salon_description_ar: null,
        salon_description_en: null,
        commercial_register: null,
        salon_number: null,
        active: true,
        registered_in_marouf: 0,
        main_section: null,
        marouf: null,
        sub_section: null,
        region: null,
        WhatsApp_contact: null,
        twitter_link: null,
        snap_link: null,
        insta_link: null,
        latitude: 24.7136,
        longitude: 46.6753,
      },

      phones: [],
      days: [],

      mapOptions: {
        zoomControl: false, // Disable the default zoom control
        disableDoubleClickZoom: true, // Disable zooming on double-click
        draggable: false, // Disable dragging the map
        clickableIcons: false, // Disable clickable icons on the map
        // More options can be added if required
      },

      additionalImages: [],
      imgUrls: [],
      main_sections: [],
      sub_sections: [],
      regions: [],

      // End:: Data Collection To Send
    };
  },

  computed: {
    ...mapGetters({
      getAppLocale: "AppLangModule/getAppLocale",
      getCountriesData: "ApiGetsModule/allCountriesData",
    }),
  },

  methods: {
    onFileSelect(files) {
      this.additionalImages = files;
    },
    onFileRemove(index) {
      this.$delete(this.imgUrls, index);
    },

    // Start:: validate Form Inputs
    validateFormInputs() {
      this.isWaitingRequest = true;
      this.submitForm();

      // if (!this.data.nameAr) {
      //   this.isWaitingRequest = false;
      //   this.$message.error(this.$t("VALIDATION.nameAr"));
      //   return;
      // } else if (!this.data.nameEn) {
      //   this.isWaitingRequest = false;
      //   this.$message.error(this.$t("VALIDATION.nameEn"));
      //   return;
      // } else {
      //   return;
      // }
    },
    countryChanged(country) {
      this.data.dialCode = country.dialCode;
      this.data.code = country.iso2;
      console.log(country);
    },
    validateInput() {
      // Remove non-Arabic characters from the input
      this.data.nameAr = this.data.nameAr.replace(/[^\u0600-\u06FF\s]/g, "");
    },
    removeArabicCharacters() {
      this.data.nameEn = this.data.nameEn.replace(this.EnRegex, "");
    },
    // End:: validate Form Inputs
    // Start:: Select Upload Image
    selectImage(selectedImage) {
      this.data.image = selectedImage;
    },
    selectImageSalon(selectedImage) {
      this.data.salon_image = selectedImage;
    },
    // End:: Select Upload Image
    // Start:: Submit Form
    async submitForm() {
      const REQUEST_DATA = new FormData();

      if (this.data.image.file) {
        REQUEST_DATA.append("user[avatar]", this.data.image.file);
      }

      if (this.data.salon_image.file) {
        REQUEST_DATA.append("salon[logo]", this.data.salon_image.file);
      }

      if (this.data.phone) {
        REQUEST_DATA.append("user[name]", this.data.phone);
      }

      if (this.data.mobile) {
        REQUEST_DATA.append("user[mobile]", this.data.mobile);
      }

      if (this.data.email) {
        REQUEST_DATA.append("user[email]", this.data.email);
      }

      if (this.data.password) {
        REQUEST_DATA.append("user[password]", this.data.password);
      }

      if (this.data.passwordConfirmation) {
        REQUEST_DATA.append(
          "user[password_confirmation]",
          this.data.passwordConfirmation
        );
      }

      if (this.data.salon_name_ar) {
        REQUEST_DATA.append("salon[name][ar]", this.data.salon_name_ar);
      }

      if (this.data.salon_name_en) {
        REQUEST_DATA.append("salon[name][en]", this.data.salon_name_en);
      }

      if (this.data.salon_description_ar) {
        REQUEST_DATA.append(
          "salon[description][ar]",
          this.data.salon_description_ar
        );
      }
      if (this.data.salon_description_en) {
        REQUEST_DATA.append(
          "salon[description][en]",
          this.data.salon_description_en
        );
      }

      if (this.data.latitude) {
        REQUEST_DATA.append("salon[lat]", this.data.latitude);
      }

      if (this.data.longitude) {
        REQUEST_DATA.append("salon[long]", this.data.longitude);
      }

      if (this.data.commercial_register) {
        REQUEST_DATA.append(
          "salon[commercial_number]",
          this.data.commercial_register
        );
      }

      if (this.data.salon_number) {
        REQUEST_DATA.append("salon[number]", this.data.salon_number);
      }

      if (this.additionalImages && this.additionalImages.length > 0) {
        this.additionalImages.forEach((file, index) => {
          REQUEST_DATA.append(`salon[images][${index}]`, file);
        });
      }

      if (this.data.main_section) {
        this.data.main_section.forEach((element, index) => {
          REQUEST_DATA.append(`salon[category_ids][${index}]`, element?.id);
        });
      }

      if (this.data.sub_section) {
        this.data.sub_section.forEach((element, index) => {
          REQUEST_DATA.append(`salon[sub_category_ids][${index}]`, element?.id);
        });
      }

      if (this.data.region) {
        REQUEST_DATA.append("salon[region_id]", this.data.region?.id);
      }

      REQUEST_DATA.append(
        "salon[maroof_number]",
        +this.data.registered_in_marouf
      );

      // REQUEST_DATA.append("is_active", is_active);
      // Start:: Append Request Data

      try {
        await this.$axios({
          method: "POST",
          url: `accepted-providers`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.addedSuccessfully"));
        this.$router.push({ path: "/providers/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },
    // End:: Submit Form

    async getMainSections() {
      this.data.sub_section = null;
      this.sub_sections = null;
      try {
        let res = await this.$axios({
          method: "GET",
          url: `categories`,
          params: {
            is_active: 1,
            page: 0,
            limit: 0,
          },
        });
        this.main_sections = res.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },

    async getSubSections() {
      try {
        const categoryIds =
          this.data.main_section?.map((section) => section.id) || [];
        let res = await this.$axios({
          method: "GET",
          url: `sub-categories`,
          params: {
            page: 0,
            limit: 0,
            is_active: 1,
            categoryIds: categoryIds,
          },
        });
        this.sub_sections = res.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },

    async getRegions() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `regions`,
          params: {
            page: 0,
            limit: 0,
            is_active: 1,
          },
        });
        this.regions = res.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },

    data: {
      salon_number: null,
      active: true,
      registered_in_marouf: 0,
      main_section: null,
      sub_section: null,
      region: null,
      latitude: 24.7136,
      longitude: 46.6753,
    },

    // start show data
    async showData() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `providers/${this.$route.params.id}`,
        });

        this.data.image.path = res.data.data?.avatar;
        this.data.salon_image.path = res.data.data?.salon.logo;
        this.data.name = res.data.data?.name;
        this.data.phone = res.data.data?.mobile;
        this.data.email = res.data.data?.email;
        this.imgUrls = res.data.data?.salon?.images;
        this.data.salon_name_ar = res.data.data?.salon?.name_ar;
        this.data.salon_name_en = res.data.data?.salon?.name_en;
        this.data.salon_description_ar = res.data.data?.salon?.description_ar;
        this.data.salon_description_en = res.data.data?.salon?.description_en;
        this.data.salon_number = res.data.data?.salon?.number;
        this.data.commercial_register = res.data.data?.salon?.commercial_number;
        this.data.registered_in_marouf = res.data.data?.salon?.maroof_number;
        this.data.marouf = res.data.data?.salon?.maroof_number;
        this.data.main_section = res.data.data?.salon?.main_categories;
        this.data.sub_section = res.data.data?.salon?.sub_categories;
        this.data.region = res.data.data?.address?.region;
        this.data.latitude = +res.data.data?.address?.lat;
        this.data.longitude = +res.data.data?.address?.long;

        this.days = res.data.data?.work_hours;

        this.phones = res.data.data?.info?.contact_numbers.map((phone) => ({
          phone: phone,
        }));

        this.data.WhatsApp_contact = res.data.data?.info?.whatsapp;
        this.data.twitter_link = res.data.data?.info?.social_media?.twitter;
        this.data.insta_link = res.data.data?.info?.social_media?.instagram;
        this.data.snap_link = res.data.data?.info?.social_media?.snapchat;
      } catch (error) {
        this.loading = false;
        console.log(error.response.data.message);
      }
    },
    // end show data
  },

  created() {
    this.showData();
    this.getMainSections();
    this.getSubSections();
    this.getRegions();
  },
};
</script>

<style lang="scss" scoped>
.images {
  display: flex;
  gap: 30px;
  flex-wrap: wrap;

  .image {
    width: 150px;
    height: 150px;
    img {
      object-fit: cover;
      border-radius: 20px;
      width: 100%;
      height: 100%;
    }
  }
}

@media (max-width: 767px) {
  .items {
    > div {
      width: 100%;
    }
  }
}
</style>
